<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href=""><i class=""></i></a>
    </div>
    <div class="account-pages my-5 pt-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <div>
              <div class="text-center"><img src="../assets/logo.png" width="200" height="70"></div>
              <h6 class="text-right mt-3">Password Reset</h6>
              <hr>

              <form action="#" @submit.prevent='verifyEmail()' class="mt-5">

                <div class="alert alert-success" role="alert" v-if="linkSent">
                  Password Reset Link has been sent to your email {{email}}
                </div>

                <div v-if="!linkSent">
                  <div class="form-group mb-3" >
                    <label> Email </label>
                    <input class="form-control txt" type="text"  placeholder="Enter your email"  v-model.trim="$v.email.$model" :class="{'is-invalid':$v.email.$error, 'is-valid':!$v.email.$invalid}">
                  </div>

                  <p class="typo__b" v-if="linkSent">Password link has be sent to email</p>
                  <!-- <p class="typo__p" v-if="noEmail">Account with this email does not exist</p> -->

                  <div class="form-group mb-3 text-center" >
                    <button class="btn btn-primary btn-sm width-lg btn-rounded" :disabled="$v.email.$invalid" type="submit" @click.prevent="verifyEmail()" style=" font-family: Poppins; font-size: 14px;" v-if="!processing"> Send </button>
                    <button class="btn btn-primary btn-sm width-lg btn-rounded" disabled type="submit" style=" font-family: Poppins; font-size: 14px;" v-if="processing"> Send </button>
                  </div>
                </div>
              </form>
            </div>
            <!-- end card -->
            <div class="row">
              <div class="col-sm-12 text-center">
                <p class="text-muted" style="color:#ccc !important">Remembered password?
                  <a href="/#/login"> Login</a>
                </p>
              </div>
            </div>
            <!-- end row -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
    <!-- end page -->
  </div>

</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'Emailforpassword',
  data() {
    return {
      email: null,
      linkSent: false,
      processing:false,
      //noEmail: false,
      token: localStorage.getItem('HTACPWV')
    };
  },
  validations: {
    email: { required, email }
  },
  methods:{
    verifyEmail(){
      this.processing=true
      this.$toastr.removeByType("error"); // remove all error type message
      // Only send after validations
      const baseU = `${this.$urlAuth}/password/recover`;
      if(this.token !== "" && this.email !== ""){
        this.$http.post(baseU, {email: this.email}, {
          headers: {
            "x-access-token": this.token
          }
        })
        .then((result) => {
          console.log(result)
          if(result.data.data.code == "S200"){
            this.linkSent = true;
            this.$toastr.s(result.data.data.message); // remove all error type message
            //this.noEmail = false;
            //this.$router.push('/setpassword')  //should not be done automatically
          }else if(result.data.data.code == "E404"){
            //this.noEmail = true;
            this.linkSent = false;
            this.$toastr.e(result.data.data.message); // remove all error type message
          }
          this.processing = false
        }).catch(err => console.log(err))
      }
    }
  }
}
</script>
